import { render, staticRenderFns } from "./MFACodePage.vue?vue&type=template&id=5d1f5dcd&"
import script from "./MFACodePage.vue?vue&type=script&lang=ts&"
export * from "./MFACodePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports